/**
 * Форматирует подпись ячейки места хранения. \
 * Паттерн как в СГП/размещении: `Num - SPIndex`, при пустом `SPIndex` — только `Num`.
 * @param cell место хранения с `Num` и `SPIndex`; `null`/`undefined` — ячейка не догружена или «на полу»
 */
export function formatStorePlaceCellName(cell: { Num: string; SPIndex: string } | null | undefined): string {
    if (cell == null) {
        return "";
    }

    return cell.SPIndex === "" ? cell.Num : `${cell.Num} - ${cell.SPIndex}`;
}
